import ms from 'ms';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';

import { Loader } from '@hivebrite/design-system/Loader';

import { TopicProvider } from 'hb-react/backoffice/contexts/TopicContext';
import PageCustomizable from 'hb-react/frontoffice/components/PageCustomizable';
import ErrorBoundary from 'hb-react/shared/components/ErrorBoundary';
import LaunchDarklyWrapper from 'hb-react/shared/components/LaunchDarklyWrapper';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const AsyncPageCustomizableContainer = ({ url, ...props }) => {
  const { isPreview, page_locale: pageLocale } = props;

  const { data: page } = useQuery(
    [`page-customizable`, url],
    () =>
      axios
        .get(`${url}.json`, {
          params: {
            draft: isPreview,
            page_locale: pageLocale,
            type: 'page_customizable',
          },
        })
        .then(
          ({ data: { page_customizable: pageCustomizable } }) =>
            pageCustomizable,
        ),
    {
      staleTime: ms('5m'),
    },
  );

  if (!page) {
    return <Loader size={50} />;
  }

  return <PageCustomizable key={page.url} {...page} {...props} />;
};

const StaticPageCustomizableContainer = ({ page, ...props }) => {
  const { page_customizable: pc } = page;

  return <PageCustomizable {...pc} {...props} />;
};

const PageCustomizableContainer = (props) => {
  const { page, topic } = props;

  const Container = page
    ? StaticPageCustomizableContainer
    : AsyncPageCustomizableContainer;

  return (
    <ErrorBoundary>
      <LaunchDarklyWrapper>
        <TopicProvider topic={topic}>
          <Container {...props} />
        </TopicProvider>
      </LaunchDarklyWrapper>
    </ErrorBoundary>
  );
};

PageCustomizableContainer.propTypes = {
  url: PropTypes.string,
  withPageTitle: PropTypes.bool,
};

export default PageCustomizableContainer;
